import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAccountFioVersionMigrationStartedAtQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
}>;


export type GetAccountFioVersionMigrationStartedAtQuery = { __typename?: 'Query', fioVersionMigration?: { __typename?: 'FioVersionMigration', recentUpMigrationStartedAt?: string | null } | null };


export const GetAccountFioVersionMigrationStartedAt = /*#__PURE__*/ gql`
    query GetAccountFioVersionMigrationStartedAt($accountId: ID!) {
  fioVersionMigration(accountId: $accountId) {
    recentUpMigrationStartedAt
  }
}
    ` as unknown as DocumentNode<GetAccountFioVersionMigrationStartedAtQuery, GetAccountFioVersionMigrationStartedAtQueryVariables>;

          

          export const useGetAccountFioVersionMigrationStartedAtQuery = (options?:QueryHookOptions<GetAccountFioVersionMigrationStartedAtQuery, GetAccountFioVersionMigrationStartedAtQueryVariables>) => useQuery(GetAccountFioVersionMigrationStartedAt, options);

          

          export type GetAccountFioVersionMigrationStartedAtQueryOptions = QueryHookOptions<GetAccountFioVersionMigrationStartedAtQuery, GetAccountFioVersionMigrationStartedAtQueryVariables>;

          

          export const useGetAccountFioVersionMigrationStartedAtLazyQuery = (options?:LazyQueryHookOptions<GetAccountFioVersionMigrationStartedAtQuery, GetAccountFioVersionMigrationStartedAtQueryVariables>) => useLazyQuery(GetAccountFioVersionMigrationStartedAt, options);

          

          export type GetAccountFioVersionMigrationStartedAtQueryResult = ReturnType<typeof useGetAccountFioVersionMigrationStartedAtQuery>;

          
